import { useEffect, useMemo } from "react";
import throttle from "lodash/throttle";

const useThrottledOnScroll = (callback: (() => void) | null, delay: number) => {
  const throttledCallback = useMemo(
    () => (callback ? throttle(callback, delay) : noop),
    [callback, delay]
  );

  useEffect(() => {
    if (throttledCallback === noop) {
      return undefined;
    }

    window.addEventListener("scroll", throttledCallback);
    return () => {
      window.removeEventListener("scroll", throttledCallback);
    };
  }, [throttledCallback]);
};

const noop = () => {};

export default useThrottledOnScroll;
